import { Reveal } from "@/components/Reveal";

const FOUNDERS = [
  {
    name: "Ayoob",
    role: "Medstifter",
    focus: "Design, kundeoplevelse & strategi",
    photo: "/founders/ayoob.jpg",
  },
  {
    name: "Yaasiin",
    role: "Medstifter",
    focus: "Webudvikling, teknik & struktur",
    photo: "/founders/yaasiin.jpg",
  },
];

export const About = () => (
  <section id="om-os" className="py-20 sm:py-28 bg-zinc-50/70" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid gap-12 lg:grid-cols-2 lg:gap-20 items-start">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-4">
            Om os
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-zinc-900">
            To grundlæggere med én mission
          </h2>
          <p className="mt-6 text-base sm:text-lg text-zinc-600 leading-relaxed">
            Naveli er grundlagt af Ayoob og Yaasiin med et simpelt mål: at gøre
            professionelle hjemmesider mere tilgængelige for små og mellemstore danske
            virksomheder. Vi arbejder direkte med vores kunder fra første idé til
            færdig hjemmeside. Ingen unødvendige mellemled, ingen komplicerede
            processer — bare tæt samarbejde, tydelig kommunikation og et resultat, vi
            kan stå inde for.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-6">
          {FOUNDERS.map((f, i) => (
            <Reveal key={f.name} delay={i * 0.12}>
              <div
                data-testid={`founder-card-${i + 1}`}
                className="group bg-white border border-zinc-200/80 rounded-2xl overflow-hidden hover:border-zinc-900 transition-colors duration-300"
              >
                <div className="aspect-[4/5] bg-zinc-100 overflow-hidden">
                  <img
                    src={f.photo}
                    alt={`${f.name}, ${f.role} i Naveli`}
                    loading="lazy"
                    data-testid={`founder-photo-${i + 1}`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-zinc-900">{f.name}</h3>
                  <p className="mt-1 text-sm font-medium text-zinc-700">{f.role}</p>
                  <p className="mt-2 text-sm text-zinc-500">{f.focus}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
